<div class="container corestyle text-center justify-content-center">
  <h1 class="h1 notfound">{{ 'PAGENOTFOUND.MAINTEXT' | translate }}</h1>
  <form class="px-5" (submit)="submitSearch()">
    <div class="input-group">
      <input class="form-control" type="text" placeholder="{{ 'BUTTON.SEARCH' | translate }}"
        [(ngModel)]="notfoundsearch" name="notfoundsearch">
        <button class="btn btn-primary text-light" type="submit"><i class="bi bi-search"></i></button>
    </div>
  </form>

  <button class="btn btn-primary text-light mt-3" routerLink="/">
    <i class="bi bi-arrow-left-circle"></i>
    Return Home
  </button>
</div>
